<script>
export default {
    name: "gallery",
    data() {
        return {
            menu: [
                { name: '展览', path: '/gallery/exhibition' },
                { name: '艺术家', path: '/gallery/artist' },
                { name: '作品总览', path: '/gallery/works' },
                { name: '最新消息', path: '/gallery/latestNews' },
                { name: '跨界活动', path: '/gallery/activities' },
                { name: '线上展厅', path: '/gallery/online' },
                { name: '关于画廊', path: '/gallery/about' },
            ],
            isShowNav: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {
        this.$store.dispatch('getGalleryHome');
    },
    destroyed() {},
    watch: {
        '$route': {
            handler: function () { 
                this.isShowNav = false;
            }
        }
    },
    methods: {},
};
</script>

<template>
    <div class="gallery">
        <!-- 移动端菜单按钮 -->
        <div class="nav_switch only_mobile" :class="{active: isShowNav}" @click="isShowNav = !isShowNav">
            <span></span><span></span><span></span>
        </div>
        <div class="wrapper flex justify_between align_center" :class="{show: isShowNav}">
            <router-link class="logo only_pc" to="/gallery"></router-link>
            <div class="menu flex justify_end">
                <div class="list flex">
                    <div class="item" v-for="(item, index) in menu" :key="index">
                        <div class="name">
                            <router-link :to="item.path">{{ item.name }}</router-link>
                        </div>
                    </div>
                </div>
                <div class="icons flex align_center only_pc">
                    <!-- <router-link class="item" to="">
                        <img src="@/assets/images/icon_shop_user.png" alt="" class="icon"/>
                    </router-link> -->
                    <router-link class="item" to="/shopping">
                        <img src="@/assets/images/icon_shop_bag.png" alt="" class="icon"/>
                    </router-link>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<style scoped lang="scss">
.nav_switch{
    @media only screen and (max-width: 750px) {
        width: .6rem;
        height: .6rem;
        border-radius: 50%;
        border: 1px solid #333;
        position: fixed;
        top: 1.9rem;
        right: .3rem;
        z-index: 11;
        background: #fff;
        span{
            width: 50%;
            height: .04rem;
            background: #333;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            &:nth-of-type(1){
                transform: translate(-50%, -250%);
            }
            &:nth-of-type(3){
                transform: translate(-50%, 150%);
            }
            transition: all .3s;
        }
        &.active{
            span{
                &:nth-of-type(1){
                    transform: translate(-50%, -50%) rotate(45deg);
                }
                &:nth-of-type(3){
                    transform: translate(-50%, -50%) rotate(-45deg);
                }
                &:nth-of-type(2){
                    opacity: 0;
                }
            }
        }
    }
}
.wrapper{
    height: .9rem;
    background: #fff;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10;
    box-shadow: 0 0 .1rem rgba($color: #000000, $alpha: .2);
    padding: 0 2.1rem 0 1rem;
    @media only screen and (max-width: 750px) {
        // display: none;
        position: fixed;
        top: 1.6rem;
        left: 0;
        width: 100%;
        height: calc(100% - 1.6rem);
        padding: 0;
        padding-top: 1.2rem;
        flex-direction: column;
        align-items: flex-end;
        z-index: 10;
        opacity: 0;
        transform: translate(100%, 0);
        transition: all .3s;
        &.show{
            opacity: 1;
            transform: translate(0, 0);
        }
    }
    .logo{
        width: 2.91rem;
        height: .44rem;
        background: url('~@/assets/images/logo_gallery.png') no-repeat 0/100%;
    }
}
.menu{
    height: 100%;
    gap: .4rem;
    @media only screen and (max-width: 750px) {
        width: 100%;
        justify-content: flex-start;
    }
    .icons{
        gap: .15rem;
        .item{
            cursor: pointer;
        }
    }
    >.list{
        // padding-right: .25rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
            flex-direction: column;
        }
        >.item{
            // &.active,
            &:hover{
                >.name{
                    background: #f8f8f8;
                    @media only screen and (max-width: 750px) {
                        background: none;
                    }
                }
                .popup{
                    display: block;
                    @media only screen and (max-width: 750px) {
                        display: none;
                    }
                }
            }
            @media only screen and (max-width: 750px) {
                &.active{
                    >.name{
                        .arrow{
                            &::after{
                                transform: translate(-50%, -50%) rotate(135deg);
                            }
                        }
                    }
                    .popup{
                        display: block;
                    }
                }
            }
            >.name{
                display: block;
                line-height: .9rem;
                font-size: .18rem;
                color: #666;
                cursor: pointer;
                @media only screen and (max-width: 750px) {
                    color: #333;
                }
                a{
                    display: block;
                    padding: 0 .15rem;
                    position: relative;
                    &::after{
                        content: "";
                        display: block;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        border-bottom: 2px solid #000;
                        display: none;
                        @media only screen and (max-width: 750px) {
                            width: auto;
                            left: .3rem;
                            right: .3rem;
                            bottom: .2rem;
                            border-bottom: 1px solid #333;
                        }
                    }
                    &.active{
                        &::after{
                            display: block;
                        }
                        @media only screen and (max-width: 750px) {
                            font-weight: bold;
                        }
                    }
                }
                @media only screen and (max-width: 750px) {
                    font-size: .32rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    a{
                        display: inline-block;
                        padding: 0 .3rem;
                    }
                    .arrow{
                        position: relative;
                        width: .9rem;
                        height: .9rem;
                        &::after{
                            content: "";
                            display: block;
                            width: .16rem;
                            height: .16rem;
                            border-top: 2px solid #666;
                            border-right: 2px solid #666;
                            transform: translate(-50%, -50%) rotate(45deg);
                            position: absolute;
                            top: 50%;
                            left: 50%;
                        }
                    }
                }
            }
        }
    }
}
</style>